import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

import { UserListViewProvider } from './UserListViewStore'
import { UserListViewActions } from './UserListViewActions.component'
import { UserListViewContent } from './UserListViewContent.component'

export function UserListView() {
  const { classes } = useStyles()
  return (
    <UserListViewProvider>
      <div className={classes.headerContainer}>
        <Typography className={classes.headline}>Users Manager</Typography>
        <UserListViewActions className={classes.headerActions} />
      </div>
      <UserListViewContent className={classes.content} />
    </UserListViewProvider>
  )
}

const useStyles = makeStyles()(({ spacing, typography, breakpoints }: Theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
  },
  headerActions: {
    display: 'flex',
  },
  content: {
    position: 'relative',
    minHeight: spacing(50),
  },
  headline: {
    display: 'inline-block',
    fontSize: typography.h5.fontSize,
    [breakpoints.down('sm')]: {
      fontSize: typography.subtitle1.fontSize,
    },
  },
}))
